<template>
  <div id="foots" class="foots">
    <div class="container">
      <div class="footer-top">
        <div class="nav-top">
          <span @click="tonav(1)">活动</span>
          <span @click="tonav(2)">领队</span>
          <span @click="tonav(3)">攻略</span>
          <span @click="tonav(4)">外链导航</span>
          <span @click="tonav(5)">关于我们</span>
          <span @click="tonav(6)">会员中心</span>
        </div>
        <div class="item-two">
          <div>地址：{{basicInfo.companyAddress}}</div>
          <div>客服热线：{{basicInfo.companyTel}}</div>
          <div>邮箱：{{basicInfo.eMail}}</div>
        </div>
      </div>
      <img :src="basicInfo.configImgs.pic4" class="code-img"/>
      <div class="footer-bottom" @click="toLink">{{basicInfo.archiveInformation}}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "foots",
  data() {
    return {
      systems: "",
      webList: "",
      systemsName: "",
      webListName: ""
    };
  },
  computed: {
    basicInfo() {
      return this.$store.state.webInfo;
    }
  },
  methods: {
    tonav(index) {
      if (index == 1) {
        this.$router.push({ path: `/activityIndex` });
      } else if (index == 2) {
        this.$router.push({ path: `/leaderList` });
      }else if (index == 3) {
        this.$router.push({ path: `/introductionList` });
      }else if (index == 4) {
        this.$router.push({ path: `/leaderList` });
      }else if (index == 5) {
        this.$router.push({ path: `/leaderList` });
      }else if (index == 6) {
        this.$router.push({ path: `/userindex/0` });
      }
    },
    toLink() {
      window.open("http://beian.miit.gov.cn");
    },
    handleSystems(command) {
      console.log("click on item " + command);
    },
    handleWebList(command) {
      console.log("click on item " + command);
    },
    //基本信息
    getInfo() {
      axios
        .get(`/mobile/cmWebBasicConfig/getCmWebBasicConfigById.jhtml`)
        .then(res => {
          this.loading = false;
          if (res.data.success) {
            this.basicInfo = res.data.output;
          } else {
            this.$message("系统繁忙，请稍后再试~");
          }
        });
    },
    //友情链接
    getLink() {
      axios.get(`/mobile/cmFriendLink/getFriendLink.jhtml`).then(res => {
        if (res.data.success) {
          this.systems = res.data.output.systems;
          this.webList = res.data.output.webList;
          this.systemsName = res.data.output.systems[0].name;
          this.webListName = res.data.output.webList[0].name;
        } else {
          this.$message("系统繁忙，请稍后再试~");
        }
      });
    }
  },
  mounted() {
    // this.getLink();
  }
};
</script>

<style scoped>
.foots {
  position: relative;
  width: 100%;
  background: #333333;
  padding: 30px 0;
  font-size: 14px;
}
.code-img{
  width: 80px;
  height: 80px;
  position: absolute;
  right: 50px;
  top: 10px;
}
.container {
  padding-top: 40px;
}
.footer-top {
  /* margin: 0 auto; */
}
.nav-top {
  cursor: pointer;
  color: #ffffff;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.nav-top > span {
  display: block;
  width: 80px;
  border-left: 1px solid #ffffff;
}
.nav-top > span:first-child {
  border: none;
}
.item-two {
  margin: 0 auto;
  color: #ffffff;
  display: flex;
  justify-content: center;
}
.item-two > div {
  padding: 0 10px;
  border-left: 1px solid #ffffff;
}
.item-two > div:first-child {
  border: none;
}
.footer-bottom {
  border-top: 1px solid #ccc;
  text-align: center;
  margin-top: 15px;
  padding-top: 15px;
  cursor: pointer;
  color: #ffffff;
}
.el-dropdown-menu {
  /* width: 150px; */
}
</style>



// WEBPACK FOOTER //
// src/components/comment/homeFoots.vue